export const monitoring = {
    "activeMonitoring": {
        "pageTitle": "Realice un seguimiento de la supervisión de los inquilinos",
        "tabs": {
            "inMonitoring": "Apts en vigilancia",
            "withoutMonitoring": "Apts sin vigilancia"
        },
        "totalTenants": "Número total de inquilinos:",
        "labels": {
            "tenantValue": "Valor del inquilino",
            "actionName": "Nombre de la acción",
            "nextActionIn": "Próxima acción en",
            "nextActionName": "Nombre de la siguiente acción",
            "sentAt": "Enviado a",
            "totalAmountMissing": "Falta la cantidad total",
            "days": "días",
            "hours": "horas",
            "tenantEmail": "Email del inquilino",
            "tenantPhone": "Teléfono del inquilino",
            "ownerEmail": "Correo electrónico del dueño",
            "ownerPhone": "Teléfono del dueño",
        },
        "actions": {
            "welcome": "bienvenida",
            "reminder":  "recordatorio de pago",
            "tenantEmail1": "Primer mensaje de correo electrónico del inquilino",
            "tenantEmail2": "Segundo mensaje de correo electrónico del inquilino",
            "tenantEmail3": "Tercer mensaje de correo electrónico del inquilino",
            "tenantEmail4": "Cuarto mensaje de correo electrónico del inquilino",
            "tenantPhone1": "SMS del primer inquilino",
            "tenantPhone2": "SMS del segundo inquilino",
            "tenantPhone3": "SMS del tercer inquilino",
            "tenantPhone4": "cuarto inquilino SMS",
            "ownerEmail1": "Primer correo electrónico del propietario",
            "ownerEmail2": "Segundo correo electrónico del propietario",
            "ownerEmail3": "Tercer correo electrónico del propietario",
            "ownerEmail4": "Cuarto correo electrónico del propietario",
            "ownerPhone1": "SMS del primer propietario",
            "ownerPhone2": "SMS del segundo propietario",
            "ownerPhone3": "SMS del tercer propietario",
            "ownerPhone4": "cuarto propietario SMS",
        },
        "btns": {
            "stopMonitoring": "Dejar de monitorear",
            "stopMonitoringApartment": "stop monitoring apartment",
            "startMonitoring": "Empezar a monitorear",
            "startMonitoringApartment": "Start monitoring apartment",
            "aptNotes": "Notas de apts",
            "startAll": "Empezar todo",
            "stopAll": "Para todo",
        },
        "successfullyStarted": "El monitoreo del apt se inició con éxito",
        "successfullyStopped": "El monitoreo del apt se detuvo con éxito",
        "successfullyAllStarted": "El monitoreo de todos los apartamentos se inició con éxito",
        "successfullyAllStopped": "El monitoreo de todos los apartamentos se detuvo con éxito",
        "somethingWentWrong": "Algo salió mal",
    }
}
